import { render, staticRenderFns } from "./TwoFactor.vue?vue&type=template&id=4c6e0ac4&"
import script from "./TwoFactor.vue?vue&type=script&lang=js&"
export * from "./TwoFactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c6e0ac4')) {
      api.createRecord('4c6e0ac4', component.options)
    } else {
      api.reload('4c6e0ac4', component.options)
    }
    module.hot.accept("./TwoFactor.vue?vue&type=template&id=4c6e0ac4&", function () {
      api.rerender('4c6e0ac4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pages/Account/Widgets/TwoFactor.vue"
export default component.exports